// extracted by css-extract-rspack-plugin
export default {"ListItemContainer":"ListItem-module__ListItemContainer__hzehD","ListItemText":"ListItem-module__ListItemText__QXqXg"};